





























































import { computed, defineComponent, ref, useContext } from '@nuxtjs/composition-api'
import accessibility from '~/utils/solepro/accessibility';
import ClientOnly from 'vue-client-only';
import Teleport from 'vue2-teleport';
import SocialLogin from '~/modules/customer/components/LoginModal/forms/SocialLogin.vue';
import { DU_STORE_CODE } from '~/utils/constants/store';
import LoginContent from './LoginContent.vue';
import { loginAvailableViews as availableViews } from '~/utils/constants/layout';
import RegisterContent from './RegisterContent.vue';
import { getShortName, getUserIsLogged } from '~/helpers/user/user';
import { useConfig } from '~/composables';

export default defineComponent({
    data() {
        return {
            modalId: 'modal-login',
            sprite: require('~/assets/solepro/spritemap.svg'),
        }
    },
    components: {
        ClientOnly,
        Teleport,
        SocialLogin,
        LoginContent,
        RegisterContent,
    },
    setup() {
        const isLoading = ref(false);
        const { error: nuxtError, app, app: { i18n, $cookies } } = useContext();
        const isLogged = computed(() => getUserIsLogged($cookies))
        const shortName = computed(() => getShortName($cookies))
        const modalBtn = ref(null);
        const loginModal = ref(null);
        const showSocialLoginButtons = ref<Boolean>(false);
        const { config } = useConfig();
        const currentView = ref<availableViews.LOGIN | availableViews.REGISTER>(availableViews.LOGIN);
        const modalTitle = computed(() => {
            return (currentView.value === availableViews.LOGIN) ? 'Benvenuto' : 'Crea un account'
        })
        const modalSubtitle = computed(() => {
            return (currentView.value === availableViews.LOGIN) ? 'Inserisci email e password per accedere ai servizi del Sole 24 Ore' : 'Hai già un account?'
        })
        return {
            modalBtn,
            loginModal,
            showSocialLoginButtons,
            availableViews,
            modalTitle,
            modalSubtitle,
            currentView,
            isLogged,
            shortName,
            isLoading,
            storeCode: config.value?.store_code
        }
    },
    watch: {
        isLogged(newVal) {
            if (newVal && process.client) {
                setTimeout(() => {
                    accessibility.accessibleModal(this.$refs.modalBtn as HTMLButtonElement)
                }, 100)
            }
        }
    },
    mounted() {
        /** Social login management */
        const loadButtons = () => {
            if (!!window['showSocialButtons'] && document.getElementById(window['_providersContainerID'])) {
                window['showSocialButtons'](DU_STORE_CODE, '', 'home2019.css');
                this.showSocialLoginButtons = true;
                clearInterval(socialInterval)
            }
        }


        const socialInterval = setInterval(() => {
            !this.showSocialLoginButtons && loadButtons();
        }, 500)

        setTimeout(() => {
            clearInterval(socialInterval)
        }, 5000)

    },
    methods: {
        adjustOverlay(overlay, isOpening = true) {
            if (isOpening) {
                overlay.classList.remove('z-10')
                overlay.classList.add('z-50')
            } else {
                overlay.classList.add('z-10')
                overlay.classList.remove('z-50')
            }
        },
        openModal() {
            const modal = document.getElementById(this.modalId)
            const overlay = document.getElementById('modal-backdrop');
            overlay.addEventListener("click", this.closeModalHandler)
            modal.addEventListener("keydown", this.keyDownHandler);
            // Add overlay before modal
            this.adjustOverlay(overlay)
            overlay.classList.remove('hidden');
            document.body.classList.add('modal-open');

            // Show modal
            modal.classList.add('show');

            setTimeout(() => {
                accessibility.simpleFocusTrap(modal)
            }, 500);
        },
        closeModal(keepOverlay: Boolean) {
            const modal = document.getElementById(this.modalId);
            const overlay = document.getElementById('modal-backdrop');
            overlay.removeEventListener("click", this.closeModalHandler)
            modal.removeEventListener("keydown", this.keyDownHandler);
        
            this.adjustOverlay(overlay, false)
            if (!keepOverlay) overlay.classList.add('hidden');
            
            if (!modal) return;
            modal.classList.remove('show');

            document.body.classList.remove('modal-open');
            this.isLoading = false;
            this.currentView = availableViews.LOGIN;
        },
        changeView(view: availableViews.LOGIN | availableViews.REGISTER) {
            this.currentView = view
        },
        closeModalHandler(evt, keepOverlay?: Boolean) {
            this.closeModal(keepOverlay)
        },
        keyDownHandler(evt) {
            if (evt.key === "Escape") {
                this.closeModal(false);
            }
        }
    }
})
